import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HandCoins } from "lucide-react";
import { api, fmtDateTime, rupiah } from "../lib/api";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

const STATUS_STYLE = { aktif: "bg-amber-500/10 text-amber-600 border-amber-500/20", lunas: "bg-emerald-500/10 text-emerald-600 border-emerald-500/20" };

export default function HutangSaldo() {
  const [list, setList] = useState(null);

  useEffect(() => { api.get("/debts").then((r) => setList(r.data)).catch(() => setList([])); }, []);

  const aktif = (list || []).filter((d) => d.status === "aktif");
  const total = aktif.reduce((s, d) => s + d.amount, 0);

  return (
    <div className="space-y-6" data-testid="hutang-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2"><HandCoins className="w-7 h-7 text-amber-500" /> Hutang Saldo</h1>
        <p className="text-sm text-muted-foreground mt-1">Pinjaman saldo dari admin yang wajib Anda lunasi.</p>
      </div>

      {list !== null && (
        <Card className="bg-gradient-to-br from-amber-500 to-orange-500 text-white border-0 shadow-lg" data-testid="hutang-total-card">
          <CardContent className="p-5 text-center">
            <div className="text-white/80 text-[11px] font-mono uppercase tracking-wider">Total Hutang Aktif</div>
            <div className="text-3xl font-extrabold font-mono tracking-tight mt-1" data-testid="hutang-total">{rupiah(total)}</div>
            {total > 0 && <div className="text-white/70 text-xs mt-1">Segera lunasi via admin — bisa potong saldo atau tunai.</div>}
            {total > 0 && (
              <Link to={`/isi-saldo?bayar=hutang&jumlah=${total}`}>
                <Button className="mt-3 bg-white text-amber-600 hover:bg-white/90 font-bold w-full" data-testid="btn-bayar-hutang">
                  Bayar Hutang
                </Button>
              </Link>
            )}
          </CardContent>
        </Card>
      )}

      <Card className="bg-card border-border shadow-sm overflow-x-auto" data-testid="hutang-list-card">
        <CardHeader><CardTitle className="text-base font-heading">Riwayat Hutang Saya</CardTitle></CardHeader>
        <Table className="w-full" data-testid="hutang-table">
          <TableHeader>
            <TableRow>
              <TableHead>Waktu</TableHead><TableHead className="text-right">Nominal</TableHead>
              <TableHead>Catatan</TableHead><TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {list !== null && !list.length && <TableRow><TableCell colSpan={4} className="text-center py-8 text-muted-foreground" data-testid="hutang-empty">Tidak ada hutang — bagus!</TableCell></TableRow>}
            {(list || []).map((d) => (
              <TableRow key={d.id} data-testid={`hutang-row-${d.id}`}>
                <TableCell className="text-[11px] font-mono text-muted-foreground whitespace-nowrap">{fmtDateTime(d.created_at)}</TableCell>
                <TableCell className="text-right font-mono font-semibold text-xs whitespace-nowrap">{rupiah(d.amount)}</TableCell>
                <TableCell className="text-xs text-muted-foreground max-w-[180px]"><span className="line-clamp-2">{d.note || "-"}</span></TableCell>
                <TableCell><span className={`px-2 py-0.5 rounded-full text-[11px] font-mono border ${STATUS_STYLE[d.status] || ""}`} data-testid={`hutang-status-${d.id}`}>{d.status === "lunas" ? "Lunas" : "Aktif"}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
